<template>
  <div v-if="menu === 0" class="all">
    <div class="right-title">
      <div class="right-title__left">
        <kpi-book-icon />
        <div class="title">{{ mainData.title }}</div>
      </div>
    </div>
    <div class="detail-subject">소개</div>
    <div class="sub-title is-18m">{{ mainData.subTitle }}</div>
    <img :src="mainData.coverImgPath" alt="imgPath" class="main-img" />
    <div class="sub-content is-14r" v-html="mainData.subContent" />
    <div class="feature">
      <div class="detail-subject">Features</div>
      <div v-for="feature in mainData.featureList" :key="'feature' + feature.id" class="feature-item" @click="goDetail(feature.id)">
        <div class="title is-16m">{{ feature.title }}</div>
        <div class="is-14r">{{ feature.subtitle }}</div>
      </div>
    </div>
    <div class="feature">
      <div class="detail-subject">Departments</div>
      <div v-for="department in mainData.departmentList" :key="'department' + department.id" class="feature-item" @click="goDetail(department.id)">
        <div class="title is-16m">{{ department.title }}</div>
        <div class="is-14r">{{ department.subtitle }}</div>
      </div>
    </div>
    <div class="feature">
      <div class="detail-subject">People & Organization</div>
      <div v-for="po in mainData.poList" :key="'po' + po.id" class="feature-item" @click="goDetail(po.id)">
        <div class="title is-16m">{{ po.title }}</div>
        <div class="is-14r">{{ po.subtitle }}</div>
      </div>
    </div>
  </div>
  <div v-else class="list">
    <div class="top-navi">
      <div v-for="(item, index) in dataTypeList" :key="'korNav' + index" :class="['nav-item', {on: item.selected}]" @click="changeNavItem(item)">
        {{ item.name }}
      </div>
    </div>
    <PropertyRightBtn class="right-btn" />
    <div class="list-container">
      <div class="search-wrap">
        <input
          type="text"
          :value="magazineSearchInfo.keyword"
          @input="inputSearchData($event)"
          placeholder="검색"
          @keyup.enter="getMagazineDataBoardListKeyword"
        />
        <search-icon class="search-icon" @click="getMagazineDataBoardListKeyword" />
      </div>
      <div class="list-wrap">
        <div class="list-top">
          <div class="top-item type">분류</div>
          <div class="top-item title">제목</div>
          <div class="top-item">분량</div>
          <div class="top-item">미리보기</div>
          <div class="top-item">형식</div>
          <div class="top-item">등급</div>
        </div>
        <div class="list-item__wrap">
          <div v-for="(magazine, idx) in magazineList" :key="'hr' + idx" class="list-item" @click="goDetail(magazine.id)">
            <div class="item-type">{{ magazine.dataTypeName }}</div>
            <div class="item-title">
              <div class="title">{{ magazine.title }}</div>
              <div class="sub-title">{{ magazine.subtitle }}</div>
            </div>
            <div class="item is-12r">{{ magazine.pageCount }}P</div>
            <div class="item">
              <download-icon v-if="magazine.previewImgPath" @click.self.stop="onClickPreviewImg(magazine.previewImgPath)" />
            </div>
            <div class="item">
              <small-pdf-icon />
            </div>
            <div :class="['rate', 'item', {paid: magazine.isPaid}]">
              {{ magazine.isPaid === 1 ? '유료' : '무료' }}
            </div>
          </div>
        </div>
        <pagination
          :total-count="magazineSearchInfo.totalCount"
          :now-page="magazineSearchInfo.page"
          :limit="magazineSearchInfo.limit"
          @changePage="listChangePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {useMagazineStore} from '~/store/magazine/index.js'
import KpiBookIcon from 'assets/svg/kpi-book-icon.vue'
import PropertyRightBtn from '~/components/common/PropertyRightBtn.vue'
import Pagination from '~/components/common/Pagination.vue'
import SmallPdfIcon from 'assets/svg/small-pdf-icon.vue'
import SearchIcon from 'assets/svg/search-icon.vue'
import DownloadIcon from 'assets/svg/download-icon.vue'

export default {
  name: 'MagazineTab2',
  components: {DownloadIcon, SearchIcon, SmallPdfIcon, Pagination, PropertyRightBtn, KpiBookIcon},
  setup() {
    const store = useMagazineStore()
    return {store}
  },
  props: {
    menu: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      naviController: 0,
      dataTypeList: [
        {
          id: '',
          name: '',
          selected: true
        }
      ],
      magazineList: [
        {
          id: 0,
          type: '',
          dataType: '',
          dataTypeName: '',
          title: '',
          subtitle: '',
          introduction: '',
          previewImgPath: null,
          pageCount: 0,
          isPaid: 0,
          price: 0
        }
      ],
      magazineSearchInfo: {
        type: '01',
        keyword: '',
        page: 1,
        limit: 20,
        totalCount: 0,
        dataType: ''
      },
      mainData: {
        title: '',
        imformationImgPath: '',
        coverImgPath: '',
        subTitle: '',
        subContent: '',
        featureList: [
          {
            id: 0,
            title: '',
            subtitle: ''
          }
        ],
        departmentList: [
          {
            id: 0,
            title: '',
            subtitle: ''
          }
        ],
        poList: [
          {
            id: 0,
            title: '',
            subtitle: ''
          }
        ]
      }
    }
  },
  mounted() {
    this.getMagazineMain()
    const subMenu = this.$route.query.subMenu
    this.initData(Number(subMenu))
  },
  watch: {
    menu(val) {
      this.initData(val)
    },
    '$route.query': {
      handler() {
        const dataType = this.$route.query.dataType
        const page = this.$route.query.page
        const keyword = this.$route.query.keyword
        if (dataType || page || keyword) {
          this.dataTypeList.forEach(item => {
            item.selected = false
            if (item.id === dataType) {
              item.selected = true
            }
          })
          this.magazineSearchInfo.dataType = dataType
          this.magazineSearchInfo.page = Number(page)
          this.magazineSearchInfo.keyword = keyword

          setTimeout(() => {
            this.getMagazineDataBoardList()
          }, 100)
        }
      },
      immediate: true
    }
  },
  methods: {
    getMagazineDataBoardListKeyword() {
      this.magazineSearchInfo.page = 1
      this.getMagazineDataBoardList()
    },
    onClickPreviewImg(url) {
      window.open(url)
    },
    initData(val) {
      // val 값을 사용하여 type을 설정
      const typeMap = {
        1: '01',
        2: '02',
        3: '03'
      }
      this.magazineSearchInfo = {
        type: typeMap[val] || '01',
        keyword: this.$route.query.keyword || '',
        page: Number(this.$route.query.page) || 1,
        limit: 20,
        totalCount: 0,
        dataType: this.$route.query.dataType || ''
      }

      this.naviController = 0
      this.getMagazineDataBoardList()
    },
    async getMagazineMain() {
      try {
        const {data} = await this.store.getMagazineMain()
        this.mainData = data
      } catch (error) {
        console.error(error)
      }
    },
    async getMagazineDataBoardList() {
      try {
        const {data} = await this.store.getMagazineDataBoardList(this.magazineSearchInfo)
        this.magazineList = data.list
        this.magazineSearchInfo.totalCount = data.count

        if (this.naviController === 0) {
          this.dataTypeList = data.dataTypeList
          this.naviController = 1
        }
        if (this.$route.query.dataType) {
          this.dataTypeList.forEach(el => {
            if (el.id === this.$route.query.dataType) {
              el.selected = true
            } else {
              el.selected = false
            }
          })
        }
        this.$router.push(
          `/magazine?menu=1&subMenu=${this.$route.query.subMenu}&dataType=${this.magazineSearchInfo.dataType}&keyword=${this.magazineSearchInfo.keyword}&page=${this.magazineSearchInfo.page}`
        )
      } catch (error) {
        console.error(error)
      }
    },
    changeNavItem(item) {
      this.dataTypeList.forEach(el => {
        el.selected = false
      })
      item.selected = true
      this.magazineSearchInfo.dataType = item.id
      this.magazineSearchInfo.page = 1

      this.getMagazineDataBoardList()
    },
    inputSearchData(e) {
      this.magazineSearchInfo.keyword = e.target.value
    },
    goDetail(id) {
      this.$router.push(
        `/magazine/board/${id}?subMenu=${this.$route.query.subMenu}&dataType=${this.magazineSearchInfo.dataType}&keyword=${this.magazineSearchInfo.keyword}&page=${this.magazineSearchInfo.page}`
      )
    },
    listChangePage(page) {
      this.magazineSearchInfo.page = page
      this.getMagazineDataBoardList()
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style scoped lang="scss">
.detail-subject {
  padding: 12px 0px;
  border-bottom: 2px solid #0058aa;
  color: #0058aa;
  font-family: 'Godo', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
}
.top-navi {
  display: flex;
  border-bottom: 1px solid #dbdbdb;
  flex-wrap: wrap;
  margin-bottom: 24px;
  .nav-item {
    padding: 18px 16px;

    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606060;
    position: relative;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;
    &:hover {
      color: #0058aa;
    }
    &.on {
      color: #0058aa;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 3px;
        background: #0058aa;
      }
    }
  }
}
.all {
  .right-title {
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
    background: #f8fbfd;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .right-title__left {
      display: flex;
      align-items: center;
      gap: 8px;
      .title {
        color: #0058aa;
        font-family: 'Godo', sans-serif;
        font-size: 18px;
        font-weight: 700;
      }
    }
    .is-14m {
      display: flex;
      padding: 7px 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 4px;
      border: 1px solid #dbdbdb;
      background: #f2f2f2;
      cursor: pointer;
    }
  }
  .sub-title {
    color: #0058aa;
    margin-bottom: 24px;
  }
  .main-img {
    width: 444px;
    height: 580px;
    margin-bottom: 24px;
  }
  .sub-content {
    white-space: pre-line;
    margin-bottom: 24px;
  }
  .feature {
    .feature-item {
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #dbdbdb;
      cursor: pointer;
    }
  }
}
.list {
  .right-btn {
    margin-bottom: 24px;
  }
  .list-container {
    .right-btn {
      margin-bottom: 24px;
    }
    .search-wrap {
      padding: 9px;
      border-radius: 4px;
      border: 1px solid #dbdbdb;
      background: #fff;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      input {
        border: none;
        width: 100%;
        outline: none;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 17.5px */
        &::placeholder {
          color: #bdbdbd;
        }
      }
      .search-icon {
        cursor: pointer;
      }
    }
    .list-wrap {
      .list-top {
        display: flex;
        border-bottom: 1px solid #909090;
        background: #fbfbfb;

        .top-item {
          padding: 12px 16px;
          width: 56px;
          color: #606060;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 125%; /* 15px */
          letter-spacing: -1px;
          &.type {
            width: 108px;
          }
          &.title {
            width: 54%;
          }
        }
      }
      .list-item__wrap {
        margin-bottom: 24px;
        .list-item {
          display: flex;
          border-bottom: 1px solid #dbdbdb;
          cursor: pointer;
          .item-type {
            width: 108px;
            color: #121212;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 125%; /* 15px */
            letter-spacing: -0.2px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .item-title {
            width: 54%;
            padding: 16px;
            .title {
              color: #121212;
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 125%; /* 17.5px */
              letter-spacing: -0.2px;
              margin-bottom: 4px;
            }
            .sub-title {
              color: #212121;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 125%; /* 15px */
              letter-spacing: -0.2px;
            }
          }
          .item {
            padding: 16px;
            width: 56px;
            display: flex;
            align-items: center;
            justify-content: center;

            &.rate {
              color: #0058aa;
              background: rgba(0, 88, 170, 0.05);
              text-align: center;
              font-family: Pretendard;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 125%; /* 17.5px */
              letter-spacing: -0.2px;
            }

            &.paid {
              color: #e40e0e;
              background: rgba(228, 14, 14, 0.05);
            }
          }
        }
      }
    }
  }
}
</style>
